import { IdentityProviderMapping } from '../types/active-directory.type';

export const newIdentityProviderMapping = (
    index: number,
    operatorField: string = '',
    identityProviderField: string = ''
): IdentityProviderMapping => ({
    index,
    identityProviderField,
    operatorField,
});

export const isValidMapping = (mappings: IdentityProviderMapping[]): boolean =>
    !mappings.some((v) => !v.operatorField || !v.identityProviderField);
